export default "__VITE_ASSET__pRf8woO7__";